import { ApiProperty } from "@nestjs/swagger";

export class SoPlantRequest {
    @ApiProperty()
    saleOrderId: number;
    @ApiProperty()
    plantId: number;
    @ApiProperty()
    stockOutType?: string;
    @ApiProperty()
    stockInType?:string
    @ApiProperty()
    fromRefNo?:number
    @ApiProperty()
    toRefNo?:number
    @ApiProperty()
    lotType?:number
    @ApiProperty()
    productId?:number
}
